import axios from 'axios'
import constants from '../constants'

export default function init() {
  console.log('call logs init')
}

export async function get(app, appSettings, type, startRange, endRange) {
  let URL = constants.isLiveEnv ? 'https://' : 'http://'
  URL = `${URL}${appSettings}/v1/${type}/sessions?beginningTimestamp=${startRange}&endingTimestamp=${endRange}&withRecordings=1`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        Authorization: `Bearer ${app.statsToken}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      let err = false
      if (error.response !== undefined && error.response.data !== undefined)
        err = error.response.data

      return err
    })
}

export async function getParticipants(
  app,
  appSettings,
  type,
  sessionID,
  beginningTimestamp,
  endingTimestamp,
) {
  let URL = constants.isLiveEnv ? 'https://' : 'http://'
  URL = `${URL}${appSettings}/v1/${type}/sessions/${sessionID}/participants?beginningTimestamp=${beginningTimestamp}&endingTimestamp=${endingTimestamp}`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        Authorization: `Bearer ${app.statsToken}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      let err = false
      if (error.response !== undefined && error.response.data !== undefined)
        err = error.response.data

      return err
    })
}

export async function downloadRecording(fileUrl, sessionID) {
  return axios({
    method: 'get',
    url: fileUrl,
    responseType: 'arraybuffer',
  })
    .then(response => {
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(
        new Blob([response.data], { type: 'application/octet-stream' }),
      )
      link.download = `${sessionID}.mp4`

      document.body.appendChild(link)

      link.click()
      setTimeout(function fn() {
        window.URL.revokeObjectURL(link)
      }, 200)
      return response.data
    })
    .catch(() => {
      const err = { error: 'You call recording cannot be downloaded. Please try again.' }
      return err
    })
}

export async function getByID(app, appSettings, sessionID, beginningTimestamp, endingTimestamp) {
  let URL = constants.isLiveEnv ? 'https://' : 'http://'
  // URL = `${URL}metrics-${app.region}.${constants.analyticsDomainV1}calls/sessions/${sessionID}`
  URL = `${URL}${appSettings}/v1/calls/sessions/${sessionID}?beginningTimestamp=${beginningTimestamp}&endingTimestamp=${endingTimestamp}`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        Authorization: `Bearer ${app.statsToken}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      let err = false
      if (error.response !== undefined && error.response.data !== undefined)
        err = error.response.data

      return err
    })
}
